
/* background: slow ribbons of light in the three tier colors; they lean toward the pointer */
(() => {
  const cv = document.getElementById('ppp-ribbons');
  if (!cv) return;
  const ctx = cv.getContext('2d');
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const TIERS = [[22, 139, 90], [65, 105, 225], [91, 42, 134]];
  const glow = TIERS.map((c) => c.map((v) => Math.min(255, Math.round(v * 1.55 + 34))));
  const every = innerWidth < 750 ? 4 : 2;
  let tickN = 0, w = 0, h = 0, t = 0, mx = 0.5, my = 0.45, tx = 0.5, ty = 0.45, raf = 0, skip = false;
  const size = () => { w = cv.width = Math.max(320, Math.round(innerWidth / 2)); h = cv.height = Math.max(320, Math.round(innerHeight / 2)); };
  function draw() {
    mx += (tx - mx) * 0.04; my += (ty - my) * 0.04;
    ctx.clearRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'lighter';
    ctx.lineWidth = 1.1;
    glow.forEach((c, k) => {
      const n = 24, ph = t * (0.7 + k * 0.22) + k * 2.1;
      for (let i = 0; i < n; i++) {
        const f = i / (n - 1);
        ctx.beginPath();
        for (let x = -24; x <= w + 24; x += 18) {
          const u = x / w;
          const y = h * (0.22 + k * 0.26 + (my - 0.5) * 0.3)
            + Math.sin(u * 3.1 + ph + f * 1.5) * h * 0.15
            + Math.sin(u * 6.8 - ph * 1.25 + f * 3.0) * h * 0.045
            + (f - 0.5) * h * 0.24 * Math.sin(u * 2.3 + ph * 0.65 + (mx - 0.5) * 2.4);
          if (x === -24) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        ctx.strokeStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + (0.05 + 0.11 * Math.sin(f * Math.PI)).toFixed(3) + ')';
        ctx.stroke();
      }
    });
  }
  function loop() {
    raf = 0;
    if (document.hidden) return;
    if (++tickN % every === 0) { t += 0.00175 * every; draw(); }
    raf = requestAnimationFrame(loop);
  }
  const start = () => { if (!raf && !still) raf = requestAnimationFrame(loop); };
  size(); draw();
  addEventListener('resize', () => { size(); draw(); });
  addEventListener('pointermove', (e) => { tx = e.clientX / innerWidth; ty = e.clientY / innerHeight; }, { passive: true });
  document.addEventListener('visibilitychange', start);
  start();
})();

/* v3.2: store search looks at product names, types, option names and tags only */
document.querySelectorAll('form[action*="/search"]').forEach((f) => { if (!f.querySelector('input[name="options[fields]"]')) { const i = document.createElement('input'); i.type = 'hidden'; i.name = 'options[fields]'; i.value = 'title,product_type,variants.title,tag'; f.appendChild(i); } });

const STORE = '';
const TIER = { essential: 'Essential', signature: 'Signature', premium: 'Premium' };
const DESC = {
  'walk-outdoor': 'Reflective harnesses and leashes, a hands-free running leash with a waist bag, a buoyancy swim vest and a glow-in-the-dark costume.',
  'dog-feeding-bowls': 'A silicone slow feeder plate, a non-slip washable food mat, a digital measuring spoon and a portable water bottle with bowl.',
  'home-comfort': 'A dog bed with a removable washable cover, an ice-silk cooling mat and a keepsake journal for life at home with your dog.',
  'grooming-care': 'A steam brush, a water spray brush, nail clippers and a rechargeable paw washer for grooming at home.',
  'travel-safety': 'A dog car seat with storage pockets and waterproof back seat covers for cleaner car trips with your dog.',
  'dog-toys-play': 'An interactive moving ball, a knit cotton chew ball and a cotton rope chew toy for fetch, tug and solo play.',
  'dog-crates-kennels': 'Crate covers for 30, 36 and 42 inch wire crates in ventilated, water-resistant and wind-resistant designs. Covers only.'
};
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ = (s) => document.querySelector(s);
const img = (src, w) => /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.includes('?') ? '&' : '?') + 'width=' + w;
const sale = (p) => p.cmp > p.price;
const money = (p) => (p.from ? 'From ' : '') + '$' + p.price.toFixed(2) + (sale(p) ? ' <s class="was">$' + p.cmp.toFixed(2) + '</s>' : '');
const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const data = window.PPP_DATA;
const P = data.products.filter((p) => p.imgs.length && p.tier);

/* hero: product photos drifting out to the sides (decorative, not clickable) */
const stream = $('#ppp-stream');
if (stream) P.filter((_, i) => i % 2 === 0).slice(0, 12).forEach((p, i) => {
  const el = document.createElement('i');
  const side = i % 2 ? 1 : -1, n = Math.floor(i / 2);
  const sm = innerWidth < 700, s = sm ? 92 + (n % 3) * 14 : 170 + (n % 3) * 40;
  el.style.cssText = `--s:${s}px;--dir:${side};--d:16s;--dl:${-(n * 16 / 6 + (side > 0 ? 1.3 : 0)).toFixed(2)}s;--y0:${n % 2 ? -14 : 12}px;--y1:${sm ? -14 + (n % 3) * 30 : -40 + (n % 3) * 46}px;--rot:${side * (4 + (n % 3) * 3)}deg;background-image:url('${img(p.imgs[0], 320)}')`;
  stream.appendChild(el);
});

/* search: best match as you type, each name in its tier color */
const box = $('#ppp-search'), q = $('#ppp-q'), out = $('#ppp-results'), anchor = $('#ppp-anchor'), dockbar = $('#ppp-dockbar');
const norm = (s) => s.toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
const catName = Object.fromEntries(data.cats);
const index = P.map((p) => ({ p, title: norm(p.t), extra: norm(p.cats.map((c) => catName[c] || '').join(' ') + ' ' + p.tier) }));
function score(it, term) {
  const words = it.title.split(' ');
  let s = 0;
  for (const t of term.split(' ')) {
    if (!t) continue;
    if (words.some((w) => w === t)) s += 12;
    else if (words.some((w) => w.startsWith(t))) s += 9;
    else if (it.title.includes(t)) s += 6;
    else if (it.extra.includes(t)) s += 3;
    else { let i = 0; for (const ch of it.title) if (ch === t[i]) i++; if (i === t.length && t.length > 2) s += 1; else return 0; }
  }
  return s + (it.title.startsWith(term) ? 6 : 0);
}
let active = -1, busyT;
function render() {
  const term = norm(q.value);
  box.classList.add('busy'); clearTimeout(busyT); busyT = setTimeout(() => box.classList.remove('busy'), 600);
  if (!term) { box.classList.remove('has-results'); out.innerHTML = ''; return; }
  const all = index.map((it) => ({ it, s: score(it, term) })).filter((h) => h.s > 0).sort((a, b) => b.s - a.s);
  const hits = all.filter((h) => all[0].s < 3 || h.s >= 3).slice(0, 6);
  active = -1;
  out.innerHTML = hits.length ? hits.map(({ it }) => `<a class="res t-${it.p.tier}" role="option" href="${STORE}/products/${it.p.h}"><img src="${img(it.p.imgs[0], 120)}" alt=""><div><b>${esc(it.p.t)}</b><span><i class="chip">${TIER[it.p.tier]}</i>${sale(it.p) ? '<i class="chip sale">On Sale</i>' : ''}${money(it.p)}</span></div></a>`).join('') : `<div class="empty">No match yet. Try "leash", "bed" or "brush", or ask us in "I Need This".</div>`;
  box.classList.add('has-results');
}
q.addEventListener('input', render);
q.addEventListener('focus', () => { if (q.value) render(); });
q.addEventListener('keydown', (e) => {
  const items = [...out.querySelectorAll('.res')];
  if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && items.length) { e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length; items.forEach((el, i) => el.classList.toggle('on', i === active)); }
  if (e.key === 'Enter') { if (items[active]) items[active].click(); else goAll(); }
  if (e.key === 'Escape') closeSearch();
});
const goAll = () => { if (q.value.trim()) location.href = '/search?q=' + encodeURIComponent(q.value.trim()) + '&options%5Bprefix%5D=last&options%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Ctag'; };
$('#ppp-go').addEventListener('click', goAll);

/* search bar position: sits in the hero, then reappears as a round button in the right corner. It never travels across the page text. */
let docked = false, open = false, gutter = 999; const measure = () => { const xs = [...document.querySelectorAll('.ppp3 .wrap, main .page-width')].map((el) => el.getBoundingClientRect()).filter((b) => b.width > 0).map((b) => b.left); gutter = xs.length ? Math.min(...xs) : 999; }; measure(); addEventListener('resize', measure);
const scrim = document.createElement('div'); scrim.className = 'scrim'; box.parentElement.insertBefore(scrim, box);
const syncScrim = () => scrim.classList.toggle('on', open || box.classList.contains('has-results'));
new MutationObserver(syncScrim).observe(box, { attributes: true, attributeFilter: ['class'] });
const pop = () => { box.classList.remove('pop'); void box.offsetWidth; box.classList.add('pop'); };
const ease = (t) => t * t * (3 - 2 * t), lerp = (a, b, t) => a + (b - a) * t;
function place() {
  /* v3.2: measure against the visible screen (visualViewport) so the bar stays in view when the phone keyboard opens */
  const vv = window.visualViewport, vt = vv ? vv.offsetTop : 0, vl = vv ? vv.offsetLeft : 0;
  const vh = vv ? vv.height : innerHeight, vw = vv ? Math.min(vv.width, document.documentElement.clientWidth) : document.documentElement.clientWidth;
  const r = anchor ? anchor.getBoundingClientRect() : { left: 0, top: -9999, width: 64 }, small = innerWidth < 1000 || gutter < 80;
  const typing = document.activeElement === q;
  const anchorSeen = r.top >= vt && r.top + 64 <= vt + vh;
  const pinTop = small && (open || (typing && !anchorSeen));
  const away = r.top + 64 < 0, e = away || open || pinTop ? 1 : 0;
  const dockX = small ? 12 : 10, dockY = vh - (small ? 74 : 96);
  const openW = Math.min(vw - dockX * 2, 420);
  const w = (open || pinTop) ? openW : away ? 64 : r.width;
  let x, y;
  if (pinTop) { x = vl + (vw - w) / 2; y = vt + 12; }
  else if (e) { x = vl + vw - dockX - w; y = vt + dockY; }
  else { x = r.left; y = r.top; }
  box.style.transform = `translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0)`;
  box.style.width = w.toFixed(1) + 'px';
  q.style.opacity = open || pinTop || !away ? 1 : 0;
  dockbar.style.display = small ? 'block' : 'none'; dockbar.style.opacity = small ? (away || open ? 1 : 0).toFixed(2) : 0; if (innerWidth >= 1000) document.body.style.paddingBottom = small ? '84px' : '';
  const nowDocked = away && !open && !pinTop;
  if (nowDocked !== docked) { docked = nowDocked; box.classList.toggle('docked', docked); if (docked) box.classList.remove('has-results'); if (!open && !box.classList.contains('anim')) pop(); }
  box.classList.toggle('up', !pinTop && y - vt > vh * 0.5);
  box.classList.toggle('pinned', pinTop);
  out.style.maxHeight = pinTop ? Math.max(140, vh - 64 - 12 - 24) + 'px' : '';
  syncScrim();
}
const glide = () => { box.classList.add('anim'); setTimeout(() => box.classList.remove('anim'), 460); };
function closeSearch() { if (open) glide(); open = false; box.classList.remove('has-results'); q.blur(); place(); }
$('#ppp-bone').addEventListener('click', () => { if (docked || open) { if (open) { closeSearch(); } else { glide(); open = true; place(); q.focus({ preventScroll: true }); } } else q.focus({ preventScroll: true }); });
document.addEventListener('pointerdown', (e) => { if (!box.contains(e.target)) { if (open) closeSearch(); else box.classList.remove('has-results'); } });
let tick = false;
const onScroll = () => { if (document.hidden) return place(); if (!tick) { tick = true; requestAnimationFrame(() => { tick = false; place(); }); } };
addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll); place();
if (window.visualViewport) { visualViewport.addEventListener('resize', onScroll); visualViewport.addEventListener('scroll', onScroll); }
q.addEventListener('focus', () => requestAnimationFrame(place)); q.addEventListener('blur', () => setTimeout(place, 80));

/* collections: tabs switch the collection; tap a small photo and it flips into the main spot */
if ($('#ppp-tabs')) {
const tabs = $('#ppp-tabs'), mainCard = $('#ppp-mainCard'), mainImg = $('#ppp-mainImg');
let cards = [], cur = 0, timer;
function paint() {
  const c = cards[cur], p = c.p;
  mainImg.src = img(c.src, 900); mainImg.alt = p.t; const lab = $('#ppp-mainLab'); if (lab) lab.textContent = p.t; mainCard.classList.toggle('sale', sale(p));
  const rest = cards.map((x, i) => i).filter((i) => i !== cur).slice(0, 4);
  const html = (i) => `<button class="pc${sale(cards[i].p) ? ' sale' : ''}" type="button" data-i="${i}" aria-label="Show ${esc(cards[i].p.t)}"><img src="${img(cards[i].src, 420)}" alt=""><span>${esc(cards[i].p.t)}</span></button>`;
  const half = Math.ceil(rest.length / 2); $('#ppp-sideL').parentElement.className = 'scene n' + cards.length; $('#ppp-sideL').innerHTML = rest.slice(0, half).map(html).join(''); $('#ppp-sideR').innerHTML = rest.slice(half).map(html).join('');
  document.querySelectorAll('.side .pc').forEach((b) => b.addEventListener('click', () => flipTo(+b.dataset.i, b)));
  $('#ppp-now').className = 'now t-' + p.tier;
  $('#ppp-now').innerHTML = `<b>${esc(p.t)}</b><i class="chip">${TIER[p.tier]}</i>${sale(p) ? '<i class="chip sale">On Sale</i>' : ''}<span>${money(p)}</span><a href="${STORE}/products/${p.h}">View product</a>`;
}
function flipTo(i, btn) {
  clearInterval(timer);
  if (reduce) { cur = i; paint(); return; }
  mainCard.classList.add('turn'); if (btn) btn.classList.add('turn');
  setTimeout(() => { cur = i; paint(); mainCard.classList.remove('turn'); auto(); }, 320);
}
function auto() { clearInterval(timer); if (!reduce && cards.length > 1) timer = setInterval(() => { if (!document.hidden) flipTo((cur + 1) % cards.length); }, 6000); }
function setCat(handle) {
  [...tabs.children].forEach((t) => t.setAttribute('aria-selected', t.dataset.h === handle));
  const items = P.filter((p) => p.cats.includes(handle)).slice(0, 5);
  cards = items.map((p) => ({ p, src: p.imgs[0] }));
  cur = 0;
  $('#ppp-cTitle').textContent = catName[handle]; $('#ppp-cDesc').textContent = DESC[handle] || '';
  $('#ppp-cLink').href = STORE + '/collections/' + handle;
  paint(); auto();
}
tabs.innerHTML = data.cats.map(([h, t]) => `<button class="tab" role="tab" type="button" data-h="${h}" aria-selected="false">${esc(t)}</button>`).join('');
[...tabs.children].forEach((t) => t.addEventListener('click', () => setCat(t.dataset.h)));
setCat(data.cats[0][0]);
}

/* scroll text + gentle reveals with Motion (content stays visible if Motion cannot load) */
const say = $('#ppp-say');
if (say) {
say.innerHTML = say.textContent.split(' ').map((w) => `<span>${w}</span>`).join(' ');
const words = [...say.children];
if (reduce) words.forEach((w) => w.classList.add('on'));
else try {
  const { scroll, animate, inView, stagger } = await import('https://cdn.jsdelivr.net/npm/motion@12/+esm');
  scroll((v) => { const n = Math.round(v * words.length * 1.15); words.forEach((w, i) => w.classList.toggle('on', i < n)); }, { target: say, offset: ['start 0.85', 'end 0.45'] });
  const rv = [...document.querySelectorAll('.ppp3 .need, .ppp3 .scene, .ppp3 .tier, .ppp3 .dogs > div')];
  rv.forEach((el) => { el.style.transform = 'translateY(28px)'; el.style.transition = 'transform .7s cubic-bezier(.22,1,.36,1)'; });
  const show = () => { for (let i = rv.length - 1; i >= 0; i--) { const el = rv[i]; if (el.getBoundingClientRect().top < innerHeight * 0.92) { el.style.transform = 'none'; rv.splice(i, 1); setTimeout(() => { el.style.transition = ''; el.style.transform = ''; }, 800); } } };
  addEventListener('scroll', show, { passive: true }); addEventListener('resize', show); show(); setTimeout(show, 600); setTimeout(show, 2000);
} catch (err) {
  const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) words.forEach((w, i) => setTimeout(() => w.classList.add('on'), i * 45)); }), { threshold: 0.4 });
  io.observe(say);
}
}
